/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isSingleSelect,
  showContaimerLoader,
  showPriceValue,
} from "../Settings/Settings";
import { apiUrl, headerconfig } from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "purchaseorder/";
var moduleName = "Purchase Order";
class Form extends Component {
  constructor(props) {
    super(props);
    var saleID = this.props.match.params?.saleID || "";
    this.state = {
      userID: userID(),
      saleID: saleID,
      postdata: {
        vendor: "",
        shipto:"",
        purchaseVoucherNumber: "",
        purchaseDate: "",
        modeofPayment: "",
        purchaseReferenceNumber: "",
        purchaseOtherReferences: "",
        purchaseDispatchedThrough: "",
        purchaseDestination: "",
        purchaseTermsofDelivery: "",
        products: [
          {
            product: "",
            qty: "",
            price: "",
            totalPrice: "",
          },
        ],
        totalPrice: 0,
        gstAmount: 0,
        gstPercentage:0,
        grandtotalPrice: 0,
      },
      detaildata: [],
      vendorList: [],
      shiptoList: [],
      productList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadVendor();
    this.loadShipto();
    this.loadProduct();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/purchaseorder");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  loadVendor() {
    var urlShringTxt =
      apiUrl + "vendors/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ vendorList: res.data.result });
      }
    });
  }
  loadShipto() {
    var urlShringTxt =
      apiUrl + "shipto/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ shiptoList: res.data.result });
      }
    });
  }
  
  loadProduct() {
    var urlShringTxt =
      apiUrl + "products/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {};

  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } }),
      () => {
        var totalPrice = this.state.postdata.totalPrice;
        var gstPercentage = (this.state.postdata.gstPercentage!=="")?this.state.postdata.gstPercentage/100:0;
        var gstAmount = totalPrice * gstPercentage;
        var grandtotalPrice = (gstAmount!=="")? (parseFloat(totalPrice) + parseFloat(gstAmount)): parseFloat(totalPrice);
        this.setState(
          update(this.state, {
            postdata: { grandtotalPrice: { $set: grandtotalPrice }, gstAmount: { $set: gstAmount } },
          }),
          () => {}
        );
      }
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      vendorID: postData.vendor?.value || "",
      purchaseShipID: postData.shipto?.value || "",
      purchaseVoucherNumber: postData.purchaseVoucherNumber,
      purchaseDate: postData.purchaseDate !== "" ? format(new Date(postData.purchaseDate), "yyyy-MM-dd") : "",
      modeofPayment: postData.modeofPayment?.value ?? '',
      purchaseReferenceNumber: postData.purchaseReferenceNumber,
      purchaseOtherReferences: postData.purchaseOtherReferences,
      purchaseDispatchedThrough: postData.purchaseDispatchedThrough,
      purchaseDestination: postData.purchaseDestination,
      purchaseTermsofDelivery: postData.purchaseTermsofDelivery,

      products: JSON.stringify(postData.products),
      purchaseAmount: postData.totalPrice,
      gstAmount: postData.gstAmount,
      gstPercentage: postData.gstPercentage,
      grandtotalPrice: postData.grandtotalPrice,
      userID: this.state.userID,
    };
    var post_url = "purchaseorder/add";
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="purchaseorder" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/purchaseorder"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            vendorList={this.state.vendorList}
                            shiptoList={this.state.shiptoList}
                            productList={this.state.productList}
                            saleID={this.state.saleID}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
 
  const { vendor, shipto } = props.fields;

  return {
    fields: ["vendor", "shipto"],
    validations: {
      vendor: [[isSingleSelect, vendor]],
      shipto: [[isSingleSelect, shipto]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPrice: this.props.fields.totalPrice,
      grandtotalPrice: this.props.fields.grandtotalPrice,
    };
  }

  goBack() {
    this.props.history.push("/" + module);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeDate(name, value) {
    this.props.onChange(name, value);
  }

  handleSelectProChange(updIndex, name, value) {
    this.updateSelectProduct(updIndex, name, value);
  }
  handleChangeText(updIndex, name, e) {
    this.updateSelectProduct(updIndex, name, e.target.value);
  }
  updateSelectProduct(updIndex, name, value) {
    var products = this.props.fields.products;
    var updPro = [];
    var totalPrice = 0;

    products.map((item, index) => {
      if (index === updIndex) {
        var product = name === "product" ? value : item.product;
        var qty = name === "qty" ? value : item.qty;
        var price = name === "price" ? value : item.price;

        var totalPrice =
          parseInt(qty) > 0 && parseFloat(price) > 0
            ? qty * parseFloat(price)
            : "";
        console.log(product?.productPrice, qty);
        updPro.push({
          product: product,
          qty: qty,
          price: price,
          totalPrice: totalPrice,
        });
      } else {
        updPro.push(item);
      }
    });
    var lastQtyVal = "";
    updPro.map((item, index) => {
      if (item.totalPrice !== "") {
        totalPrice += parseFloat(item.totalPrice);
      }
      if (
        item.qty !== "" &&
        item.product !== "" &&
        updPro.length === parseInt(index) + 1
      ) {
        lastQtyVal = "Yes";
      }
    });
    if (lastQtyVal === "Yes") {
      updPro.push({
        product: "",
        qty: "",
        price: "",
        totalPrice: "",
      });
    }
    this.props.onChange("products", updPro);
    setTimeout(() => {
      this.setState({ totalPrice: totalPrice }, () => {
        this.props.onChange("totalPrice", totalPrice);
      });
    }, 800);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgvendor, errMsgshipto = "";

    if ($validation.vendor.error.reason !== undefined) {
      errMsgvendor = $validation.vendor.show && (
        <span className="error">{$validation.vendor.error.reason}</span>
      );
    }
    if ($validation.shipto.error.reason !== undefined) {
      errMsgshipto = $validation.shipto.show && (
        <span className="error">{$validation.shipto.error.reason}</span>
      );
    }
    

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            {this.props.saleID === "" && (
              <div className="form-group col-md-4">
                <label className="form-label">
                  Vendor<span className="lbl-error">*</span>
                </label>
                <Select
                  value={fields.vendor}
                  onChange={this.handleSelectChange.bind(this, "vendor")}
                  placeholder="Select Vendor"
                  isClearable={true}
                  options={this.props.vendorList}
                />
                {errMsgvendor}
              </div>
            )}
          </div>

          {fields.vendor !== "" && (
            <div className="row pt-5">
              <div className="col-lg-6">
                <p className="h3">Sale To:</p>
                <p className="fs-18 fw-semibold mb-0">{fields.vendor?.label}</p>
                <address>
                  {fields.vendor?.vendorAddress}, <br />
                  <br />
                  Contact Person:{fields.vendor?.vendorContactPerson}
                  {fields.vendor?.vendorPhone !== "" &&
                    fields.vendor?.vendorPhone !== null && (
                      <>
                        <br />
                        {fields.vendor?.vendorPhone}
                      </>
                    )}
                  {fields.vendor?.vendorEmail !== "" &&
                    fields.vendor?.vendorEmail !== null && (
                      <>
                        <br />
                        {fields.vendor?.vendorEmail}
                      </>
                    )}
                  {fields.vendor?.vendorGSTNo !== "" &&
                    fields.vendor?.vendorGSTNo !== null && (
                      <>
                        <br />
                        <b>GSTNo.:</b>
                        {fields.vendor?.vendorGSTNo}
                      </>
                    )}
                </address>
              </div>
              <div className="col-lg-6 text-end"></div>
            </div>
          )}
          <div className="form-group col-md-4">
            <label className="form-label">
              Ship To<span className="lbl-error">*</span>
            </label>
            <Select
              value={fields.shipto}
              onChange={this.handleSelectChange.bind(this, "shipto")}
              placeholder="Select Ship To"
              isClearable={true}
              options={this.props.shiptoList}
            />
            {errMsgshipto}
          </div>
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">Voucher No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Voucher No."
                name="purchaseVoucherNumber"
                value={fields.purchaseVoucherNumber}
                {...$field("purchaseVoucherNumber", (e) =>
                  onChange("purchaseVoucherNumber", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Date</label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.purchaseDate}
                dateFormat="dd-MM-yyyy"
                placeholderText="Date"
                onChange={this.handleChangeDate.bind(
                  this,
                  "purchaseDate"
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Mode/Terms of Payment</label>
              <Select
                value={this.state.modeofPayment}
                onChange={this.handleSelectChange.bind(this, "modeofPayment")}
                placeholder="Select Mode of Payment"
                isClearable={true}
                options={[
                  {
                    label: "NIFFT",
                    value: "NIFFT",
                  },
                  {
                    label: "Cheque",
                    value: "Cheque",
                  },
                  {
                    label: "Cash",
                    value: "Cash",
                  },
                ]}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Reference No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Reference No."
                name="purchaseReferenceNumber"
                value={fields.purchaseReferenceNumber}
                {...$field("purchaseReferenceNumber", (e) =>
                  onChange("purchaseReferenceNumber", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Other References</label>
              <input
                type="text"
                className="form-control"
                placeholder="Other References"
                name="purchaseOtherReferences"
                value={fields.purchaseOtherReferences}
                {...$field("purchaseOtherReferences", (e) =>
                  onChange("purchaseOtherReferences", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Dispatched through</label>
              <input
                type="text"
                className="form-control"
                placeholder="Dispatched through"
                name="purchaseDispatchedThrough"
                value={fields.purchaseDispatchedThrough}
                {...$field("purchaseDispatchedThrough", (e) =>
                  onChange("purchaseDispatchedThrough", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Destination</label>
              <input
                type="text"
                className="form-control"
                placeholder="Destination"
                name="purchaseDestination"
                value={fields.purchaseDestination}
                {...$field("purchaseDestination", (e) =>
                  onChange("purchaseDestination", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Terms of Delivery</label>
              <textarea
                className="form-control"
                placeholder="Terms of Delivery"
                name="purchaseTermsofDelivery"
                {...$field("purchaseTermsofDelivery", (e) =>
                  onChange("purchaseTermsofDelivery", e.target.value)
                )}
                rows="3"
                defaultValue={fields.purchaseTermsofDelivery}
              />
            </div>
          </div>
          <div className="push">
            <table className="table table-bordered table-hover mb-0 text-nowrap">
              <tbody>
                <tr>
                  <th className="text-center"></th>
                  <th style={{ width: "50%" }}>Item</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-end">Unit Price</th>
                  <th className="text-end">Sub Total</th>
                </tr>
                {fields.products.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">{parseInt(index) + 1}</td>
                      <td>
                        {this.props.saleID !== "" ? (
                          <div>{item.product.label}</div>
                        ) : (
                          <Select
                            value={item.product}
                            onChange={this.handleSelectProChange.bind(
                              this,
                              index,
                              "product"
                            )}
                            placeholder="Select Product"
                            isClearable={true}
                            options={this.props.productList}
                          />
                        )}
                      </td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Qty"
                          name="qty"
                          value={item.qty}
                          autoComplete="off"
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "qty"
                          )}
                          maxLength={6}
                        />
                      </td>
                      <td className="text-end">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Price"
                          name="price"
                          autoComplete="off"
                          value={item.price}
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "price"
                          )}
                        />
                      </td>
                      <td className="text-end">
                        {showPriceValue(item.totalPrice)}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    Total
                  </td>
                  <td className="fw-bold text-end h4">
                    {showPriceValue(this.state.totalPrice)}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    GST Precentage
                  </td>
                  <td className="fw-bold text-end h4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="GST"
                      name="gstPercentage"
                      {...$field("gstPercentage", (e) =>
                        onChange("gstPercentage", e.target.value)
                      )}
                      value={fields.gstPercentage}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    GST Amount
                  </td>
                  <td className="fw-bold text-end h4">
                    {showPriceValue(fields.gstAmount)}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    Grand Total
                  </td>
                  <td className="fw-bold text-end h4">
                    {showPriceValue(fields.grandtotalPrice)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Create Purchase
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
